import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledInput = styled.input<{ $compact?: boolean }>`
  color: ${tvar('colors.typography.default')};
  background: ${tvar('colors.fill.primary')};
  border: 0.1rem solid ${tvar('colors.fill.primary')};
  padding: ${({ theme, $compact }) =>
    $compact ? theme.space.x1 : theme.space.x2};
  width: 100%;
  min-width: 10rem;
`;

export const StyledInputWrapper = styled.div`
  display: flex;

  label + & {
    margin-top: ${tvar('space.x1')};
  }

  &:not(:last-child) {
    margin-bottom: ${tvar('space.x2')};
  }
`;

export const StyledInputHorizontalContainer = styled.div`
  display: flex;
  margin-bottom: ${tvar('space.x2')};

  & > div:first-child {
    flex: 1 1 auto;
    margin-right: ${tvar('space.x2')};
  }

  ${StyledInputWrapper} {
    min-width: 10rem;
    width: auto;
    flex: 0 1 auto;
  }

  ${StyledInput} {
    align-self: flex-start;
  }
`;

export const StyledDescription = styled.p`
  font-weight: 300;
  font-size: 1.4rem;
  letter-spacing: 0.01em;
  display: block;
  margin-bottom: ${tvar('space.half')};
`;

export const StyledInputPrefix = styled.span`
  background: ${tvar('colors.neutrals.grey1')};
  display: flex;
  align-items: center;
  padding: ${tvar('space.x2')};
`;
